import PartnersService from "./partners.service";
import OrganizationsService from "./organizations.service";
import EventsService from "./events.service";
import GroupService from "./groups.service";
import GuestsService from "./guests.service";
import StorageService from "./storage.service";
import InternalService from "./internal.service";
import UserService from "./user.service";
import UsersService from "./users.service";
import CheckinLogsService from "./checkin-logs.service";
import InvitesService from "./invites.service";

const ApiService = {
  user: UserService,
  partners: PartnersService,
  organizations: OrganizationsService,
  events: EventsService,
  groups: GroupService,
  guests: GuestsService,
  storage: StorageService,
  users: UsersService,
  checkinLogs: CheckinLogsService,
  invites: InvitesService,
  internal: InternalService,
};

export default ApiService;
